/***
 *
 *   FORM IMAGE UPLOAD — pure helpers
 *
 *   Extracted from builder.js so the one invariant that matters can actually be
 *   tested: what gets handed back to survey-creator's upload callback.
 *
 *   Three of its five upload call sites ignore the callback status and assign
 *   the second argument straight onto the property (survey-creator-core.js
 *   :6424-6431, :8022, :8034). Passing an error MESSAGE there wrote that
 *   sentence into survey.logo and rendered it as a broken <img src> — the bug
 *   this whole change exists to fix, and a one-line "improvement" away from
 *   coming back.
 *
 **********/

import { isRenderableImageUrl } from "components/survey/formTheme";

export const EMPTY_SNAPSHOT = { element: null, propertyName: null, value: "" };

/*
 * resolveRestore()
 * what is safe to hand back when an upload fails.
 *
 * Only ever a storable https URL or "". Keyed on element AND property, because
 * a snapshot taken for one element must never be restored onto another; and the
 * caller consumes it once, because a snapshot left by a cancelled file dialog
 * would otherwise restore a value the user has since replaced.
 */

export function resolveRestore(snapshot, options) {
  if (!snapshot || !options) return "";

  const matches =
    snapshot.element === options.element &&
    snapshot.propertyName === options.propertyName;

  if (!matches) return "";

  return isRenderableImageUrl(snapshot.value) ? snapshot.value : "";
}

/*
 * validateImageFile()
 * mirrors the server's checks so the common rejection never round-trips.
 * The server remains authoritative; returns null or a sentence.
 */

export function validateImageFile(file, { acceptedTypes, maxBytes, hint }) {
  if (!file) return "No file was selected.";
  if (file.size > maxBytes) return `That image is too large. ${hint}`;
  if (!acceptedTypes.includes(file.type)) return `That file type isn't supported. ${hint}`;
  return null;
}
